module.exports = __webpack_public_path__ + "img/ME.ad7afd12.svg";